<template>
    <b-modal
        :hide-footer="true"
        :title="'Entrega de Benefício'"
        centered
        size="md"
        id="entrega-beneficio"
        :visible="false"
        :no-close-on-backdrop="true"
    >
        
        <div>
            <load v-if="loading" mode="table" />
            <div v-else class="row">
                <form class="col-12" @submit.prevent="submit">
                    <div class="row">
                        <form-calendar
                            :max-date="dataNow"
                            v-model="data_entrega"
                            label="Data da entrega"
                            :required="true"
                            grid="4"
                        />
                        <form-input
                            grid="8"
                            v-model="nome_entregador"
                            label="Nome entregador"
                            :required="true"
                        />
                        <form-toggle v-model="tipo_recepetor_familia" grid="12" label="Recebido por uma pessoa da família"/>
                        <form-select
                            v-model="nome_recepetor"
                            label="Quem recebeu"
                            :itens="familiares"
                            :required="true"
                            v-if="tipo_recepetor_familia"
                        />
                        <form-input v-else
                            v-model="nome_recepetor"
                            label="Quem recebeu"
                            :required="true"
                            grid="8"
                        />
                        <form-input v-if="tipo_recepetor_familia == false" grid="4" v-model="cpf"  label="CPF quem recebeu"/>
                        <form-select
                            v-model="local"
                            label="Local entrega"
                            :itens="itensLocalEntrega"
                            :required="true"
                            grid="6"
                        />
                        <form-input
                            v-model="beneficio.valor"
                            label="Valor a ser entregue"
                            grid="6"
                            type="text"
                            inputGroup="true"
                            btnText="R$"
                            @input="formatarValor"
                            :required="true"
                            v-if="this.beneficio.beneficio.categoria == 1"
                        />
                        <form-input
                            grid="6"
                            v-model="quantidade_entrega"
                            label="Quantidade entregue"
                            :required="true"
                            type="number"
                            min="1"
                            :max="beneficio.quantidade - beneficio.quantidade_entregue"
                            v-if="this.beneficio.beneficio.categoria != 1"
                        />
                        <form-toggle 
                            v-model="entregar_tudo" 
                            @input="setQuantidade" 
                            label="Será entregue toda a quantidade?"
                            v-if="this.beneficio.beneficio.categoria != 1"
                        />
                        
                        <form-textarea
                            v-model="descricao"
                            label="Observação"
                        />
                    </div>

                    <div class="row pt-1 px-2 d-flex justify-content-end">
                        <button
                            type="submit"
                            class="btn btn-success btn-submit"
                        >
                            <i class="mdi mdi-content-save" />
                            {{ $t("Salvar") }}
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <div
        v-if="loading == false && tentativas.length > 0"
        class="col-12 px-0 mt-2"
        >
            <h5><b>{{ tentativas.length }}</b> tentativa(s) anterior(es)</h5>
            <div  style="max-height: 300px; overflow: auto">
                <div
                    class="border p-2"
                    v-for="tentativa of tentativas"
                    :key="tentativa.id"
                >
                    <p class="mb-1">
                        <b>Data tentativa </b>
                        {{ tentativa.data_tentativa | formatDateHora}}
                    </p>
                    <p class="mb-1">
                        <b>Nome entregador </b>
                        {{ tentativa.nome_entregador }}
                    </p>
                    <p class="mb-1">
                        <b>Observação </b>
                        {{ tentativa.descricao }}
                    </p>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    props: ["beneficio", "statusAnterior", "familiares"],
    data() {
        return {
            dataNow                  : moment().format("YYYY/MM/DD"),
            data_entrega             : new Date,
            tipo_recepetor_familia   : true,
            nome_recepetor           : "",
            nome_entregador          : "",
            descricao                : "",
            cpf                      : "",
            local                    : "",
            quantidade_entrega       : 1,
            show                     : false,
            loading                  : false,
            entregar_tudo            : false,
            familiares               : [],
            numero_tentativas        : 0,
            tentativas               : [],
            municipio                : "",
            locaisEntregaPorMunicipio: {
                default: [
                    { id: 'NA UNIDADE', value: 'NA UNIDADE' },
                    { id: 'NA RESIDÊNCIA', value: 'NA RESIDÊNCIA' }
                ],
                caraguatatuba: [
                    { id: "CIASC PONTE SECA", value: "CIASC PONTE SECA" },
                    { id: "CIASC PEREQUÊ MIRIM", value: "CIASC PEREQUÊ MIRIM" },
                    { id: "BANCO DE ALIMENTOS", value: "BANCO DE ALIMENTOS" },
                    { id: "NÚCLEO JOÃO BOLINHA", value: "NÚCLEO JOÃO BOLINHA" },
                    { id: "NÚCLEO ALTO DO JETUBA", value: "NÚCLEO ALTO DO JETUBA" },
                    { id: "NÚCLEO PEDRA GRANDE", value: "NÚCLEO PEDRA GRANDE" },
                ],
            }
        };
    },
    watch: {
        beneficio() {
            if(this.beneficio.proxima_entrega){
                this.tentativas = this.beneficio.proxima_entrega.tentativas;
            }

            if (this.beneficio.familia == null) return;

            this.familiares = this.beneficio.familia.familiares.map(e => { return {
                id: e.nome_completo,
                value: e.nome_completo
            }});
        },
    },
    mounted() {
        this.buscarMunicipio();
    },
    computed: {
        itensLocalEntrega() {

            const municipio = this.municipio.trim().toLowerCase();

            if (municipio == "caraguatatuba"){
            
                return this.locaisEntregaPorMunicipio[municipio];
                
            }else{
                
                return this.locaisEntregaPorMunicipio.default;
                
            }

        }
    },
    methods: {
        async buscarMunicipio() {
            this.municipio = this.$store.state.municipio.toLowerCase();
        },
        formatarValor() {

            // Remove tudo o que não for número
            let valor = this.beneficio.valor.replace(/\D/g, '');

            // Adiciona o ponto de milhar e formata com a vírgula para centavos
            if (valor.length > 2) {
                valor = valor.replace(/(\d)(\d{2})$/, '$1,$2');
            }
            if (valor.length > 6) {
                valor = valor.replace(/(\d)(\d{3})(\d{3})$/, '$1.$2.$3');
            }

            // Atualiza o valor formatado no v-model
            this.beneficio.valor = valor;

        },
        setQuantidade(){

            if(this.entregar_tudo){

                if (this.beneficio.quantidade == null){

                    this.beneficio.quantidade = 1;

                }

                this.quantidade_entrega = this.beneficio.quantidade - this.beneficio.quantidade_entregue;
            }else{

                this.quantidade_entrega = 1

            }

        },
        submit() {
            this.loading = true;

            let dados = {
                beneficio_id              : this.beneficio.id,
                data_entrega              : this.data_entrega,
                nome_recepetor            : this.nome_recepetor,
                nome_entregador           : this.nome_entregador,
                descricao                 : this.descricao,
                local                     : this.local,
                cpf_recepetor             : this.cpf,
                numero_tentativas         : this.numero_tentativas,
                quantidade_entrega        : this.quantidade_entrega,
                entregue                  : 1
            };

            let url = "api/dashboard/beneficio/entrega/store"; 
            if(this.beneficio.proxima_entrega){
                dados.numero_tentativas = this.beneficio.proxima_entrega.numero_tentativas + 1;
                dados.id = this.beneficio.proxima_entrega.id;
                url = "api/dashboard/beneficio/entrega/update";
            }

            axios
                .post(url, dados)
                .then((response) => {
                    this.$snack.success({
                        button: false,
                        text: "Histórico salvo com sucesso.",
                    });
                    this.load = false;
                })
                .finally(() => {
                    this.loading = false;
                    this.$emit("submit");
                    if(this.statusAnterior != this.beneficio.status_liberacao) this.saveHistory();
                    this.clear();
                    this.$bvModal.hide("entrega-beneficio");
                });
            

        },
        saveHistory() {
            let data = "";
            let observacoes = "";
           
            this.data_entrega = moment(this.data_entrega,"YYYY-MM-DD" ).format("DD/MM/YYYY");
            if (this.data_entrega) {
                data = this.data_entrega;
            }
            observacoes = this.descricao;
            
            axios.post("api/dashboard/status/historico", {
                id: this.beneficio.id,
                observacoes: observacoes,
                status_anterior: this.statusAnterior,
                status_atual: this.beneficio.status_liberacao,
                data: data,
                module: "Beneficio",
                model: "BeneficioLiberado",
            });
        },
        clear() {
            Object.assign(this.$data, this.$options.data.call(this));
        },
    },
};
</script>
